import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
interface Props {
  listData?: any,
  onChange?: (data: any) => void,
}
// Dữ liệu giả lập
const initialMenuItems = [
  { id: '1', name: 'Họ và tên (customerName)', status: true },
  { id: '2', name: 'Mã định danh (identityNumber)', status: false },
  { id: '3', name: 'Số điện thoại (customerPhone)', status: true },
  { id: '4', name: 'Email (customerMail)', status: false },
  { id: '5', name: 'Tình trạng hôn nhân (maritalStatus)', status: false },
  { id: '6', name: 'Nghề nghiệp (Occupation)', status: false },
];

const DragDropTitle: React.FC<Props> = ({ listData, onChange }) => {
  const [menuItems, setMenuItems] = useState([] as any);
  useEffect(() => {
    setMenuItems(listData)
  }, [listData])
  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;

    const items = Array.from(menuItems);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setMenuItems(items);
    if (onChange) {
      onChange(items)
    }
  };

  const iconDrag = `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 4.5C7 4.89782 7.15804 5.27936 7.43934 5.56066C7.72064 5.84196 8.10218 6 8.5 6C8.89782 6 9.27936 5.84196 9.56066 5.56066C9.84197 5.27936 10 4.89782 10 4.5C10 4.10218 9.84197 3.72064 9.56066 3.43934C9.27936 3.15804 8.89782 3 8.5 3C8.10218 3 7.72064 3.15804 7.43934 3.43934C7.15804 3.72064 7 4.10218 7 4.5Z" fill="#98A2B3"/><path d="M14 4.5C14 4.89782 14.158 5.27936 14.4393 5.56066C14.7206 5.84196 15.1022 6 15.5 6C15.8978 6 16.2794 5.84196 16.5607 5.56066C16.842 5.27936 17 4.89782 17 4.5C17 4.10218 16.842 3.72064 16.5607 3.43934C16.2794 3.15804 15.8978 3 15.5 3C15.1022 3 14.7206 3.15804 14.4393 3.43934C14.158 3.72064 14 4.10218 14 4.5Z" fill="#98A2B3"/><path d="M7 12C7 12.3978 7.15804 12.7794 7.43934 13.0607C7.72064 13.342 8.10218 13.5 8.5 13.5C8.89782 13.5 9.27936 13.342 9.56066 13.0607C9.84197 12.7794 10 12.3978 10 12C10 11.6022 9.84197 11.2206 9.56066 10.9393C9.27936 10.658 8.89782 10.5 8.5 10.5C8.10218 10.5 7.72064 10.658 7.43934 10.9393C7.15804 11.2206 7 11.6022 7 12Z" fill="#98A2B3"/><path d="M14 12C14 12.3978 14.158 12.7794 14.4393 13.0607C14.7206 13.342 15.1022 13.5 15.5 13.5C15.8978 13.5 16.2794 13.342 16.5607 13.0607C16.842 12.7794 17 12.3978 17 12C17 11.6022 16.842 11.2206 16.5607 10.9393C16.2794 10.658 15.8978 10.5 15.5 10.5C15.1022 10.5 14.7206 10.658 14.4393 10.9393C14.158 11.2206 14 11.6022 14 12Z" fill="#98A2B3"/><path d="M7 19.5C7 19.8978 7.15804 20.2794 7.43934 20.5607C7.72064 20.842 8.10218 21 8.5 21C8.89782 21 9.27936 20.842 9.56066 20.5607C9.84197 20.2794 10 19.8978 10 19.5C10 19.1022 9.84197 18.7206 9.56066 18.4393C9.27936 18.158 8.89782 18 8.5 18C8.10218 18 7.72064 18.158 7.43934 18.4393C7.15804 18.7206 7 19.1022 7 19.5Z" fill="#98A2B3"/><path d="M14 19.5C14 19.8978 14.158 20.2794 14.4393 20.5607C14.7206 20.842 15.1022 21 15.5 21C15.8978 21 16.2794 20.842 16.5607 20.5607C16.842 20.2794 17 19.8978 17 19.5C17 19.1022 16.842 18.7206 16.5607 18.4393C16.2794 18.158 15.8978 18 15.5 18C15.1022 18 14.7206 18.158 14.4393 18.4393C14.158 18.7206 14 19.1022 14 19.5Z" fill="#98A2B3"/>`

  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <Droppable droppableId="menu">
        {(provided) => (
          <ul {...provided.droppableProps} ref={provided.innerRef} className="drag-drop-content" >
            {menuItems.map((item: any, index: any) => (
              <Draggable key={item.id} draggableId={item.id} index={index}>
                {(provided: any) => (
                  <li
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className="one-op"
                  >
                    <div className="icon" dangerouslySetInnerHTML={{ __html: iconDrag }} />
                    <div className="text">
                      {item.name}
                      {item.status ? (
                        <span>*</span>
                      ) : ('')}
                    </div>
                  </li>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </ul>
        )}
      </Droppable>
    </DragDropContext>
  );
}

export default DragDropTitle;
